import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    error: null,
    notificationListData: [],
    pushNotificationPushed: false
}
export const notification = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        notificationListLoad: (state) => {
            state.loading = true
        },
        notificationListSuccess: (state, action) => {
            state.loading = false
            state.notificationListData = action.payload
        },
        notificationListFail: (state) => {
            state.loading = false
        },

        createNewPushNotificationLoad: (state) => {
            state.loading = true
            state.pushNotificationPushed = false
        },
        editPushNotificationLoad: (state) => {
            state.loading = true
            state.pushNotificationPushed = false
        },
        deletePushNotificationLoad: (state) => {
            state.loading = true
            state.pushNotificationPushed = false
        },
        createNewPushNotificationSuccess: (state, action) => {
            state.loading = false
            state.pushNotificationPushed = true
        },
        createNewPushNotificationFail: (state) => {
            state.loading = false
            state.pushNotificationPushed = false
        },
    }
});

export const {
    notificationListLoad,
    notificationListFail,
    notificationListSuccess,
    createNewPushNotificationLoad,
    editPushNotificationLoad,
    deletePushNotificationLoad,
    createNewPushNotificationSuccess,
    createNewPushNotificationFail
} = notification.actions;
export default notification.reducer;